import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadTurntableCompletion,
  loadTurntableWinnersCompletion,
  lotteryTurntableCompletion,
  loadTurntableCountCompletion,
} from '../../actions';

export function* watchLoadTurntable() {
  yield takeEvery('LOAD_TURNTABLE', function*({ tid }) {
    const options = {
      url: `/api/cj/${tid}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadTurntableCompletion(tid, result.error, result.data));
  });
}

export function* watchLoadTurntableWinners() {
  yield takeEvery('LOAD_TURNTABLE_WINNERS', function*({ tid }) {
    const options = {
      url: `/api/cj/${tid}/orders`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadTurntableWinnersCompletion(tid, result.error, result.data));
  });
}

export function* watchLoadTurntableCount() {
  yield takeEvery('LOAD_TURNTABLE_COUNT', function*({ tid }) {
    const options = {
      url: `/api/cj/count/${tid}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadTurntableCountCompletion(tid, result.error, result.data));
  });
}

export function* watchLotteryTurntable() {
  yield takeEvery('LOTTERY_TURNTABLE', function*({ tid }) {
    const options = {
      url: `/api/cj/${tid}/lottery`,
      method: 'POST',
      data: { id: tid },
    };
    const result = yield call(app.httpFetch, options);
    yield put(lotteryTurntableCompletion(tid, result.error, result.data));
  });
}

export default function* turntableSaga() {
  yield all([
    fork(watchLoadTurntable),
    fork(watchLoadTurntableWinners),
    fork(watchLotteryTurntable),
    fork(watchLoadTurntableCount),
  ]);
}
